import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link } from "react-router-dom";

const API_URL = "https://sunrise-backend.sunrisemeditechsystems.com/api";

export default function Shop() {
  const [products, setProducts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("");
  const [sortBy, setSortBy] = useState("name");
  const [sortOrder] = useState("asc");
  const [viewMode, setViewMode] = useState("grid");
  const [userData, setUserData] = useState(null);

  useEffect(() => {
    const userDataStr = localStorage.getItem('userData');
    if (userDataStr) {
      setUserData(JSON.parse(userDataStr));
    }
  }, []);

  useEffect(() => {
    fetchProducts();
    fetchCategories();
  }, [searchTerm, selectedCategory, sortBy, sortOrder]);

  const fetchProducts = async () => {
    setLoading(true);
    try {
      const params = {};
      if (searchTerm) params.search = searchTerm;
      if (selectedCategory) params.category = selectedCategory;
      if (sortBy) params.sortBy = sortBy;
      if (sortOrder) params.sortOrder = sortOrder;

      const response = await axios.get(`${API_URL}/products`, { params });
      setProducts(response.data);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching products:", error);
      setLoading(false);
    }
  };

  const fetchCategories = async () => {
    try {
      const response = await axios.get(`${API_URL}/categories`);
      setCategories(response.data);
    } catch (error) {
      console.error("Error fetching categories:", error);
    }
  };

  if (!userData || (userData.role !== 'admin' && userData.role !== 'receptionist')) {
    return (
      <div className="content-page">
        <div className="content">
          <div className="container-fluid">
            <div className="alert alert-warning mt-5">
              Access denied. Only admin and receptionist can browse products.
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="content-page">
      <div className="content">
        <div className="container-fluid">
          {/* Page Title */}
          <div className="row mb-4">
            <div className="col-12">
              <div className="page-title-box d-flex align-items-center justify-content-between">
                <h4 className="mb-0">Medical Equipment Shop</h4>
                <div className="page-title-right">
                  <nav aria-label="breadcrumb">
                    <ol className="breadcrumb m-0">
                      <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                      <li className="breadcrumb-item active">Shop</li>
                    </ol>
                  </nav>
                </div>
              </div>
            </div>
          </div>

          {/* Search and Filter Section */}
          <div className="row mb-4 item-content">
            <div className="col-12 col-lg-8">
              <div className="item-shop">
                <div className="position-relative flex-grow-1">
                  <input
                    type="text"
                    className="form-control search-product"
                    placeholder="Search products..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                  />
                  <i 
                    className="fas fa-search search-icon"
                  ></i>
                </div>

                <select
                  className="form-select search-sort"
                  value={sortBy}
                  onChange={(e) => setSortBy(e.target.value)}
                >
                  <option value="name">Sort by Name</option>
                  <option value="salePrice">Sort by Sale Price</option>
                  <option value="rentalPrice">Sort by Rental Price</option>
                </select>
              </div>
            </div>
          </div>

          {/* Products Grid */}
          <div className="row">
            {loading ? (
              <div className="col-12 text-center p-5">
                <div className="spinner-border text-primary" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              </div>
            ) : products.length === 0 ? (
              <div className="col-12 text-center p-5">
                <div className="alert alert-info">
                  <i className="mdi mdi-information-outline me-2"></i>
                  No products found
                </div>
              </div>
            ) : (
              <div className="row" style={{ margin: '0 -20px',width:"100%"}}>
                {products.map((product) => (
                  <div
                    key={product.id}
                    className="col-xl-3 col-lg-4 col-md-6"
                    style={{ padding: '20px' }}
                  >
                    <div 
                      className="card h-100 product-card border-0"
                      style={{
                        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                        borderRadius: '12px',
                        transition: 'all 0.3s ease',
                        backgroundColor: '#fff',
                        margin: '0',                       
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.transform = 'translateY(-5px)';
                        e.currentTarget.style.boxShadow = '0 8px 16px rgba(0,0,0,0.1)';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.transform = 'none';
                        e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.1)';
                      }}
                    >
                      <div className="position-relative" style={{ padding: '15px 15px 0' }}>
                        <img
                          src={`https://sunrise-backend.sunrisemeditechsystems.com${product.image}`}
                          alt={product.name}
                          className="card-img-top"
                          style={{
                            height: "220px",
                            objectFit: "contain",
                            borderRadius: '8px',
                            backgroundColor: '#f8f9fa',
                          }}
                        />
                        {(product.saleStock <= 0 && product.rentalStock <= 0) && (
                          <div 
                            style={{
                              position: 'absolute',
                              top: 0,
                              left: 0,
                              right: 0,
                              bottom: 0,
                              margin: '15px 15px 0',
                              background: 'rgba(255,255,255,0.9)',
                              borderRadius: '8px',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                            }}
                          >
                            <span className="badge bg-danger px-3 py-2">Out of Stock</span>
                          </div>
                        )}
                      </div>
                      <div className="card-body p-4">
                        <h5 className="card-title" style={{ fontSize: '1.1rem', marginBottom: '10px', height: '40px', overflow: 'hidden' }}>
                          <Link to={`/product/${product.id}`} className="text-decoration-none text-dark">
                            {product.name}
                          </Link>
                        </h5>
                        <p className="card-text text-muted" style={{ fontSize: '0.9rem', height: '45px', overflow: 'hidden' }}>
                          {product.description}
                        </p>
                        <div className="d-flex justify-content-between align-items-center my-3">
                          <div>
                            <span className="h5 text-primary mb-0">₹{product.salePrice}</span>
                            <small className="text-muted ms-1"> Buy</small>
                          </div>
                        </div>
                        <div className="d-flex flex-wrap gap-2 mb-3">
                          {product.saleStock > 0 && (
                            <span className="badge bg-success-subtle text-success px-2 py-1">
                              <i className="mdi mdi-check-circle me-1"></i>Buy Available
                            </span>
                          )}
                          {product.standByStock > 0 && (
                            <span className="badge bg-success-subtle text-success px-2 py-1">
                              <i className="mdi mdi-check-circle me-1"></i>Stand By Available
                            </span>
                          )}
                            {product.demoStock > 0 && (
                            <span className="badge bg-success-subtle text-success px-2 py-1">
                              <i className="mdi mdi-check-circle me-1"></i>Demo Available
                            </span>
                          )}
                        </div>
                        <Link
                          to={`/product/${product.id}`}
                          className="btn btn-primary w-100"
                          style={{
                            borderRadius: '8px',
                            padding: '8px 16px',
                            fontWeight: '500',
                            marginTop: 'auto'
                          }}
                        >
                          View Details
                        </Link>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}